import { createSlice } from "@reduxjs/toolkit"

const initialState = {
  searchValue: {
    propertyType: [],
    isLease: ""
  },
  spaceList: [],
  mySpace: [],
  isOpenModal: false
};

export const APIResponseSlice = createSlice({
  name: "GetProfile",
  initialState,
  reducers: {
    setSearchValue: (state, action) => {
      state.searchValue = action.payload
    },
    setSpaceList: (state, action) => {
      state.spaceList = action.payload
    },
    mySpace: (state, action) => {
      state.mySpace = action.payload
    },
    openInfoModal: (state, action) => {
      state.isOpenModal = action.payload
    }
  },

  // name: "GetEmployerProfile",
  // employerState,
  // reducers: {
  //   getBusinessDetails: (state, action) => {
  //     state.businessDetails = action.payload
  //   },
  // },

});

// Action creators are generated for each case reducer function
export const {
  setSearchValue,
  setSpaceList,
  mySpace,
  openInfoModal
} = APIResponseSlice.actions;

export default APIResponseSlice.reducer;
